module.exports = __webpack_public_path__ + "static/media/1009197.f0ce0f00.png";